<!-- 
日期选择
监听 prop 中的 value
并依据其 new Date(value) 的结果作为对应的时间和日期
当用户选择了新的日期后，触发 input 事件  
 -->

<template>
  <date-picker :name="dpname" v-model="dpdate" :config="options" @dp-change="changeValue"></date-picker>
</template>

<script>
  //import 'bootstrap/dist/css/bootstrap.css';
  import datePicker from 'vue-bootstrap-datetimepicker';
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
  import moment from 'moment'

  export default {
    name: "mmf-datepicker",
    components: {
      datePicker
    },
    props: {
      "name": {
        type: String
      },
      "date": {
        type: Object,
        default: () => null,
      },
      // 时间的字符串表示 
      // 如 "2019-10-01"
      // 只要可以作为 new Date() 的参数就可以
      'value': {
        type: String
      }
    },
    data: function () {
      return {
        dpname: this.name,
        // Date 类型， 日期
        dpdate: this.date || new Date(this.value),
        options: {
          // https://momentjs.com/docs/#/displaying/
          format: 'YYYY-MM-DD',
          useCurrent: false,
          showClear: true,
          showClose: true,
          icons: {
            time: 'fa fa-clock',
            date: 'fa fa-calendar',
            up: 'fa fa-arrow-up',
            down: 'fa fa-arrow-down',
            previous: 'fa fa-chevron-left',
            next: 'fa fa-chevron-right',
            today: 'fa fa-calendar-check',
            clear: 'fa fa-trash-alt',
            close: 'fa fa-times-circle'
          }
        }
      }
    },
    computed: {
      // string 类型， 格式化之后的日期
      dpdateFormatted() {
        if (this.dpdate != null) {
          return moment(this.dpdate).format('YYYY-MM-DD')
        } else {
          return ""
        }
      }
    },
    methods: {
      changeValue: function ($event) {
        const moment = $event.date
        if (moment) {
          this.dpdate = moment.toDate()
        } else {
          this.dpdate = null
        }
        this.$emit('input', this.dpdateFormatted);
      }
    },
    mounted() {
      console.log({value:this.value})
      if (this.value == "") this.$emit('input', this.dpdateFormatted);
      else {
        var str = this.value;
        this.dpdate = new Date(str)
      }
    },
    watch: {
      value: function (val) {
        if (val == "") {
          this.dpdate = null;
        } else {
          this.dpdate = new Date(val)
        }
      }
    },
  }
</script>